// dateUtils.js

export function formatDateToCustomString(isoDateString) {
  var fecha = new Date(isoDateString);
  var year = fecha.getUTCFullYear();
  var month = fecha.getUTCMonth() + 1;
  var day = fecha.getUTCDate();
  var hours = fecha.getUTCHours();
  var minutes = fecha.getUTCMinutes();
  var seconds = fecha.getUTCSeconds();

  month = month < 10 ? '0' + month : month;
  day = day < 10 ? '0' + day : day;
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;

  var formattedFecha = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  return formattedFecha;
}
